import { useState } from "react";
import AddressForm from "./AddressForm";
import ImageWrapper from "../ImageComponent/ImageWrapper";
import GMapsComponent from "@/components/AddressComponent/GMapsComponent";
import { normalizeGoogleAddress } from "./normalizeGoogleAddress";

const AddressFlowModal = ({
                            userData,
                            closeAddressModal,
                            handleAddAddress,
                            otpHandlers,
                            editAddressData = null
                          }) => {
  // ✅ FIX: skip map for edit
  const [step, setStep] = useState(editAddressData ? "FORM" : "MAP");

  const [coords, setCoords] = useState(
    editAddressData?.coordinates || {}
  );
  const [autoFilledAddress, setAutoFilledAddress] = useState({});
  const initialData = {
    name: editAddressData?.name || userData?.userName || "",
    userDataEmail: userData?.email || "",
    email: editAddressData?.email || userData?.email || "",
    phoneNumber: editAddressData?.phoneNumber || userData?.phone || "",

    pincode: editAddressData?.pincode || autoFilledAddress.pincode || "",
    areaLocation:
      editAddressData?.areaLocation || autoFilledAddress.areaLocation || "",
    landmark:
      editAddressData?.landmark || autoFilledAddress.landmark || "",
    city: editAddressData?.city || autoFilledAddress.city || "",
    state: editAddressData?.state || autoFilledAddress.state || "",

    country: "India",
    default: editAddressData?.default || false,
    coordinates: coords
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-ModalTransparentColor">
      <div className="flex flex-col bg-white w-full h-full md:w-3/6 lg:w-2/5 xl:w-1/3 md:h-[85vh] md:rounded-lg">

        {/* HEADER */}
        <header className="flex justify-between items-center border-b p-4">
          <h3 className="font-semibold">
            {step === "MAP"
              ? "Select puja location"
              : editAddressData
                ? "Edit address"
                : "Add new address"}
          </h3>
          <button className="w-4 h-4" onClick={closeAddressModal}>
            <ImageWrapper src="/icons/Cancelbutton.svg" alt="Close" />
          </button>
        </header>

        {/* BODY */}
        <div className="flex-1 overflow-hidden">
          {step === "MAP" ? (
            <GMapsComponent
              onGMapsContinue={(coordinates, place) => {
                const normalizedAddress = normalizeGoogleAddress(place);
                setCoords(coordinates);
                setAutoFilledAddress(normalizedAddress);
                setStep("FORM");
              }}
              closeAddressModal={closeAddressModal}
            />
          ) : (
            <AddressForm
              editAddressForm={editAddressData}
              initialData={initialData}
              onSubmit={handleAddAddress}
              otpHandlers={otpHandlers}
              onBack={editAddressData ? null : () => setStep("MAP")}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AddressFlowModal;
